__turbopack_context__.v({
  "close-button": "PromoModal-module-scss-module__NlWZtq__close-button",
  "image": "PromoModal-module-scss-module__NlWZtq__image",
  "image-link": "PromoModal-module-scss-module__NlWZtq__image-link",
  "popup": "PromoModal-module-scss-module__NlWZtq__popup",
});
